// extracted by mini-css-extract-plugin
module.exports = {"emptyCopy":"Blocks__emptyCopy__IeOSl","emptyCta":"Blocks__emptyCta__rwolw"};